import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { contactInfo } from '../mockData';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_web-clone-project-10/artifacts/h37p4abd_image.png" 
              alt="OpaLink Telecom" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-orange-500 transition-colors font-medium">
              Início
            </Link>
            <Link to="/sobre-nos" className="text-gray-700 hover:text-orange-500 transition-colors font-medium">
              Sobre nós
            </Link>
            <Link to="/para-voce" className="text-gray-700 hover:text-orange-500 transition-colors font-medium">
              Para você
            </Link>
            <Link to="/para-sua-empresa" className="text-gray-700 hover:text-orange-500 transition-colors font-medium">
              Para sua empresa
            </Link>
            <Link to="/atendimento" className="text-gray-700 hover:text-orange-500 transition-colors font-medium">
              Atendimento
            </Link>
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center space-x-4">
            {/* App Download Links */}
            <div className="flex items-center space-x-2 border-r pr-4">
              <span className="text-xs text-gray-600">Baixe o app:</span>
              <a
                href="https://apps.apple.com/app/opalink/id6758806645"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-70 transition-opacity"
                title="Baixar na App Store"
              >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                </svg>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.provenduz.opalink"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-70 transition-opacity"
                title="Baixar no Google Play"
              >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
              </a>
            </div>
            
            <a
              href={contactInfo.clientAreaLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
            >
              Área do cliente
            </a>
            <a
              href={contactInfo.clientAreaLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600 transition-colors font-medium"
            >
              2ª via fatura
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Início
              </Link>
              <Link
                to="/sobre-nos"
                className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Sobre nós
              </Link>
              <Link
                to="/para-voce"
                className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Para você
              </Link>
              <Link
                to="/para-sua-empresa"
                className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Para sua empresa
              </Link>
              <Link
                to="/atendimento"
                className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
                onClick={() => setMobileMenuOpen(false)}
              >
                Atendimento
              </Link>
              <a
                href={contactInfo.clientAreaLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
              >
                Área do cliente
              </a>
              <a
                href={contactInfo.clientAreaLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600 transition-colors font-medium text-center"
              >
                2ª via fatura
              </a>
              
              {/* App Download Links - Mobile */}
              <div className="pt-4 border-t mt-4">
                <p className="text-sm text-gray-600 mb-3">Baixe o app OpaLink:</p>
                <div className="flex gap-3">
                  <a
                    href="https://apps.apple.com/app/opalink/id6758806645"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 bg-black text-white px-4 py-2 rounded-lg text-sm text-center hover:bg-gray-800 transition-colors"
                  >
                    App Store
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.provenduz.opalink"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex-1 bg-black text-white px-4 py-2 rounded-lg text-sm text-center hover:bg-gray-800 transition-colors"
                  >
                    Google Play
                  </a>
                </div>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
